import { RichTextBlock } from 'prismic-reactjs'
import { FC } from 'react'
import styled from 'styled-components'

import { media } from '../../utils/style-utils'
import RichText from '../RichText'
import { backgroundColors } from '../../styles/backgroundColors'

interface IStepCard {
	item: {
		stepNumber: number
		stepText: RichTextBlock[]
	}
	darkMode: boolean
}

const StepCard: FC<IStepCard> = ({ item, darkMode }) => (
	<StyledStepCard darkMode={darkMode}>
		<StyledStepNumber darkMode={darkMode}>{item.stepNumber}</StyledStepNumber>
		<StyledStepText
			darkMode={darkMode}
			content={item.stepText}
		/>
	</StyledStepCard>
)

export default StepCard

const StyledStepCard = styled.div<{ darkMode: boolean }>`
	border-radius: 40px;
	display: flex;
	flex: 1 0 calc(33.33% - 24px);
	min-width: calc(33.33% - 24px);
	background-color: ${(props) => (props.darkMode ? 'var(--blue-700)' : 'var(--step-card)')};

	${media.tablet`
		min-width: unset;
		flex: 1 0 100%;
		border-radius: 24px;
	`}
`
const StyledStepNumber = styled.span<{ darkMode: boolean }>`
	font-family: var(--font-atyp-display);
	font-weight: 500;
	font-size: 1.5rem;

	position: absolute;
	width: 56px;
	height: 56px;
	margin-top: 16px;
	margin-left: 16px;

	background-color: ${(props) => (props.darkMode ? backgroundColors('Deep Blue') : backgroundColors('Neon'))};
	color: ${(props) => (props.darkMode ? 'var(--neon)' : 'var(--deep-blue)')};
	border-radius: 50%;

	display: flex;
	justify-content: center;
	align-items: center;

	${media.tablet`
        width: 48px;
        height: 48px;
        margin: .5rem 1rem 0 .5rem;
        color: var(--deep-blue);
        background-color: var(--neon);
    `}
`

const StyledStepText = styled(RichText)<{ darkMode: boolean }>`
	p {
		text-align: left;
		padding: 29px 32px 24px 95px;
		font-family: var(--font-atyp-display);
		font-size: 1.5rem;
		line-height: 2rem;
		margin: 0;
		color: ${(props) => (props.darkMode ? 'var(--neon)' : 'var(--deep-blue)')};

		${media.tablet`
            font-size: 1.125rem;
            padding: 16px 16px 24px 70px;
        `}
	}
`
